const usePlatform = (slug) => {
  const platformPattern = /(react|web|angular)/;
  const pathMatches = slug.match(platformPattern);
  const platform = pathMatches !== null ? pathMatches[1] : false;
  return platform;
};

export default usePlatform;
